import { Container } from 'unstated'
import axios from 'axios'
import makeRequest from '../requests/base.request'
import * as GamificacaoRequest from '../requests/gamificacao.request';

const dateTimeFormatOptions = { "year": "numeric", "month": "short", "day": "2-digit", "hour": "2-digit", "minute": "2-digit" }
const localDateTimeFormat = new Intl.DateTimeFormat('pt-BR', dateTimeFormatOptions);

const initialState = {
  selectedEventPracticeTest: 0,
  selectedPeriodSchoolGrade: 0,
  selectedPracticeTestType: 0,
  selectedPeriodPracticeTest: 0,
  selectedTestType: 0,
  selectedPeriod: 0,
  selectedGrade: {},
  selectedSchool: {},
  // alunosChecked: [],
  simulado: {
    dtEndEvent: new Date(),
    dtStartEvent: new Date(),
    inExamBlockWindow: false,
    inContinueExam: true
  },
  settings: true,
  periodos: [],
  fireRedirect: false,
  dadosangedamento: {},
  action: '',//this is going to be used to check if the action is AGENDAR, EDITAR or REAGENDAR
  agendamentos: [],
  treeViewAlunos: {
    checked: [],
    expanded: [],
    nodes: []
  },
  currentAgandamento: {}, //this is going to stored the values of the Agenda Selected

  loading: false,
  loadingTabela: false,
  study: {
    idStudy:0,
    dtEndStudy: new Date(),
    dtStartStudy: new Date(),
    inHasSummary:false
  },
  treeViewAlunosEstudo: {
    checked: [],
    expanded: [],
    nodes: []
  },
  selectedStudy:0,
  selectedStudies:[]
}

class PracticeTestContainer extends Container {
  state = {
    ...initialState
  }


  simuladosAgendados = []
  setAction = async (action) => {
    await this.setState(
      {
        action: action
      }
    )
  }

  //Clean page
  setInitialState = async (school) => {
    await this.setState(() => {
      return {
        ...initialState,
        selectedSchool: school
      };
    });
  }

  organizedDateHour(date) {
    // console.log('date',date)
    // formatação de acordo com o locale pt-BR
    var formatted = localDateTimeFormat.format(date)
    // console.log('formatted',formatted)
    var result = formatted.split(" ");
    // 01 de mar de 2019 20:43
    // ^  ^  ^   ^  ^    ^
    // |  |  |   |  |    |
    // 0  1  2   3  4    5
    return result[0] + "/" + result[2] + " " + result[5];
  }

  organizedDate(date) {
    // formatação de acordo com o locale pt-BR
    var formatted = localDateTimeFormat.format(date)
    var result = formatted.split(" ");
    // 01 de mar de 2019 20:43
    // ^  ^  ^   ^  ^    ^
    // |  |  |   |  |    |
    // 0  1  2   3  4    5
    return result[0] + "/" + result[2];
  }

  periodsApi = async (idEntitySchool, idGrade) => {
    try {
      const response = await makeRequest.get(`simulado?grade=${idGrade}&school=${idEntitySchool}`);
      if (response && response.length) {
        let periods = response[0];
        if (periods && periods.length > 0) {
          for (var p in periods) {
            let start = this.organizedDate(periods[p].dtStartPeriod);
            periods[p].rawStartPeriod = periods[p].dtStartPeriod;
            periods[p].dtStartPeriod = start;
            let end = this.organizedDate(periods[p].dtEndPeriod);
            periods[p].rawEndPeriod = periods[p].dtEndPeriod;
            periods[p].dtEndPeriod = end;
          }
          //  console.log('periodis ',periods)
          await this.setState({ periodos: periods });
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }



  getCurrentDateHour = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/portal/hora-oficial`);
      if (response && response.data) {
        var result = JSON.parseWithDate(response.data.body);
        if (result.Atual) {
          return result.Atual
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }


  //SIMULADOS AGENDADOS TABELA SIMULADOS
  agendaApi = async (idEntitySchool, idGrade) => {
    try {
      // const response = await makeRequest.get(`simulado/agendamento?school=${idEntitySchool}&grade=${idGrade}`);
      let response = await makeRequest.get(`api/adaptativa/agendamento/listar-agendamento-escola?school=${idEntitySchool}&grade=${idGrade}`, true);
      //       console.log('agendamentosAPI ', agendamentosAPI)
      // console.log(`simulado/agendamento?school=${idEntitySchool}&grade=${idGrade}`)
      // console.log('response',response)


      let agendamentosAPI = response;//response.ret[0];
      let agendamentos = [];

      for (var a in agendamentosAPI) {

        let agendamentoValues = {};
         // console.log(agendamentosAPI[a])
        /**
         * TIPO AGENDAMENTO = 4  = TURMA
         * TIPO AGENDAMENTO = 1 = ALUNOS
         */
        //  agendamentoValues.tipoAgendamento = agendamentosAPI[a].a[0].typoagendamento;
        agendamentoValues.idPracticeTestType = agendamentosAPI[a].idPracticeTestType;
        agendamentoValues.idPeriodPracticeTest = agendamentosAPI[a].idPeriodPracticeTest;
        agendamentoValues.idEventPracticeTest = agendamentosAPI[a].idEventPracticeTest;
        agendamentoValues.idEvent = agendamentosAPI[a].idEvent;
        //var currentDate = await this.getCurrentDateHour()
        // var reagendarAtivo = agendamentosAPI[a].dtEndEvent < (currentDate || new Date());
        agendamentoValues.reagendarAtivo = agendamentosAPI[a].reagendarAtivo;
        agendamentoValues.editarTurma = agendamentosAPI[a].editarTurma;
        agendamentoValues.excluirTurma = agendamentosAPI[a].excluirTurma;
        agendamentoValues.editarAlunos = agendamentosAPI[a].editarAlunos;
        agendamentoValues.excluirAlunos = agendamentosAPI[a].excluirAlunos;
// console.log('agendamentosAPI[a].dtStartEvent',agendamentosAPI[a].dtStartEvent)
        agendamentoValues.dtStartEvent = this.organizedDateHour(Date.parse(agendamentosAPI[a].dtStartEvent));
        agendamentoValues.dtEndEvent = this.organizedDateHour(Date.parse(agendamentosAPI[a].dtEndEvent));
        // console.log('parrrr ',agendamentosAPI[a].idsAccountPracticeTestDone)

        agendamentoValues.EventToClass = agendamentosAPI[a].EventToClass
        agendamentoValues.ExistsExam = agendamentosAPI[a].ExistsExam
        agendamentoValues.emAndamento = (agendamentosAPI[a].emAndamento === 1);
        agendamentoValues.nuPracticeTestDone = agendamentosAPI[a].nuPracticeTestDone
        if(agendamentosAPI[a].idsAccountPracticeTestDone) {
          agendamentoValues.idsAccountPracticeTestDone = JSON.parse(agendamentosAPI[a].idsAccountPracticeTestDone).filter(value => (value.PracticeTestDone === 1 )).map(value => value.idUser);
        }
        agendamentoValues.nuPracticeTestTotal = agendamentosAPI[a].nuPracticeTestTotal
        agendamentoValues.turmas = JSON.parse(agendamentosAPI[a].ac)

//           console.log(agendamentoValues)

        agendamentos.push(agendamentoValues)

      }
        console.log('agendamentos ', agendamentos)
      if (agendamentos.length > 0) {
        this.setState({ agendamentos: agendamentos });
      } else {
        this.setState({ agendamentos: [] });
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  settingsApi = async (idEntitySchool, idGrade) => {
    try {
      const response = await makeRequest.get(`configuracoes/status?grade=${idGrade}&school=${idEntitySchool}`)
      return response === true
    }
    catch (e) {
      console.log(e);
    }
  }

  //Agendar and Edit. this will  help to check if there is no any period already schedule for the same type of test with the same time period.
  saveTurmasAgendadas = async () => {
    try {

      const response = await makeRequest.get(`simulado/agendamento/turmas?idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&idEventPracticeTest=${this.state.selectedEventPracticeTest}&idPracticeTestType=${this.state.selectedPracticeTestType}`)
      // console.log('saveTurmasAgendadas ', response.marcados[0])
      var turmasAgendadas = response.marcados[0]

      let turmasAlerta = [];//This are the ones that the user has to uncheck in order to be able to create new agenda.
      if (turmasAgendadas === null) {
        return await this.agendarSimulado()
      } else {
        let turmasChecked = this.state.simulado.arrIdAccountMembers.split(',')

        for (var e in turmasAgendadas) {
          for (var a in turmasChecked) {
            if (turmasAgendadas[e].idAccount === 't_' + turmasChecked[a]) {
              turmasAlerta.push(turmasAgendadas[e])
            }
          }
        }

        var turmasName = "";
        if (turmasAlerta.length > 0) {
          for (var it in turmasAlerta) {
            turmasName = turmasName + " " + turmasAlerta[it].txClassName;
          }
          // alert(`As turmas ${turmasName} já foram agendadas previamente`)
          return `As turmas ${turmasName} já foram agendadas previamente`;
        } else {
          return await this.agendarSimulado()
        }
      }
    } catch (e) {
      console.log(e);
    }

  }

  /**
   * this method will check if there are Agendas created for that Class
   * Same idClass but different simulation type. Dates can not be overlap
   * return Boolean
   */
  validarAgendasDaTurma = async () => {
    try {
      let isValidDate = false;
      //   console.log('practice test type selected ',this.state.selectedPracticeTestType)
      let tipo = this.state.selectedPracticeTestType;
      /**
       * types are 1 Diagnostico, 2 Desenvolvimento, 3 Evolução
       */
      let typeA = "";
      let typeB = "";

      if (tipo === 1) {
        // console.log('typo 1')
        typeA = 2;
        typeB = 3;
      }
      if (tipo === 2) {
        // console.log('typo 2')

        typeA = 1;
        typeB = 3;
      }
      if (tipo === 3) {
        // console.log('typo 3')

        typeA = 2;
        typeB = 1;
      }


      //let turmasChecked = this.state.simulado.arrIdAccountMembers.split(',')

      const responseTypeA = await makeRequest.get(`simulado/agendamento/turmas?idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&idEventPracticeTest=${this.state.selectedEventPracticeTest}&idPracticeTestType=${typeA}`)
      // console.log('turmasChecked need to compared',turmasChecked)
      // console.log('type a ',responseTypeA.marcados)

      if (responseTypeA.marcados.length > 0 && responseTypeA.marcados[0] !== null) {



        var turmasAgendadasTypeA = responseTypeA.marcados[0][0]
        if (!this.checkOverlapingDates(turmasAgendadasTypeA)) {
          ///  console.log('date is not overlap type a')
          isValidDate = true;
          return isValidDate;
        } else {
          // console.log('date is  overlap type a')
          return isValidDate;
        }
      }

      const responseTypeB = await makeRequest.get(`simulado/agendamento/turmas?idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&idEventPracticeTest=${this.state.selectedEventPracticeTest}&idPracticeTestType=${typeB}`)
      //   console.log('type b',responseTypeB)
      // console.log('responseTypeB  ', responseTypeB.marcados)

      if (responseTypeB.marcados.length > 0 && responseTypeB.marcados[0] !== null) {
        var turmasAgendadasTypeB = responseTypeB.marcados[0][0]
        if (!this.checkOverlapingDates(turmasAgendadasTypeB)) {
          //    console.log('date is not overlaped type b')

          isValidDate = true;
          return isValidDate;

        } else {
          // console.log('date is overlaped type b')
          return isValidDate;

        }
      }
      //    console.log('datase are valid??? ', isValidDate)
      //return isValidDate;
    } catch (e) {
      console.log(e);
    }

  }

  /**
   * Checagem de dados.
   * @param  agendamento object
   * @return boolean
   */
  checkOverlapingDates(agendamento) {
    let isOverlaping = false;
    // console.log('checkOverlapingDates agendamento ', agendamento, 'current dates ', this.state.simulado)
    /**
     * COMPARE ALREADY CREATED AGENDA DATES WITH THE CURRENT PRETENDED ONE
     */
    let agendaStartDate = agendamento.dtStartEvent;
    let agendaEndDate = agendamento.dtEndEvent;

    let selectedStartDate = this.state.simulado.dtStartEvent;
    let selectedEndDate = this.state.simulado.dtEndEvent;

    if ((selectedStartDate < agendaStartDate) && (agendaStartDate < selectedEndDate) && (selectedEndDate < agendaEndDate)) {
      /**
       * DATE OVERLAPING, PRETENDING ENDING DATE IS BETWEEN THE AGENDA´S DATES.
       */
      isOverlaping = true;
      return isOverlaping;
    }
    if (agendaStartDate < selectedStartDate && selectedStartDate < agendaEndDate) {
      //inital date is overlaping
      isOverlaping = true;
      return isOverlaping;

    }
    if (agendaStartDate < selectedEndDate && selectedEndDate < agendaEndDate) {
      //end date is overlaping
      isOverlaping = true;
      return isOverlaping;

    }

    // console.log('dates not overlaping')
    return isOverlaping;
  }

  validarAgendasDaTurmaMultipleChecked = async () => {
    try {
      let isValidDate = false;
      //   console.log('practice test type selected ',this.state.selectedPracticeTestType)
      let tipo = this.state.selectedPracticeTestType;
      /**
       * types are 1 Diagnostico, 2 Desenvolvimento, 3 Evolução
       */
      let typeA = "";
      let typeB = "";

      if (tipo === 1) {
        //  console.log('typo 1')
        typeA = 2;
        typeB = 3;
      }
      if (tipo === 2) {
        //console.log('typo 2')

        typeA = 1;
        typeB = 3;
      }
      if (tipo === 3) {
        //console.log('typo 3')

        typeA = 2;
        typeB = 1;
      }


      let turmasChecked = this.state.simulado.arrIdAccountMembers.split(',')

      const responseTypeA = await makeRequest.get(`simulado/agendamento/turmas?idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&idEventPracticeTest=${this.state.selectedEventPracticeTest}&idPracticeTestType=${typeA}`)
      // console.log('--> responseTypeA', responseTypeA)
      // console.log('turmasChecked need to compared',turmasChecked)
      // console.log('type a ',responseTypeA.marcados)


      if (responseTypeA.marcados.length > 0 && responseTypeA.marcados[0] !== null) {
        var turmasAgendadasTypeA = responseTypeA.marcados[0]

        for (var e in turmasAgendadasTypeA) {
          for (var a in turmasChecked) {
            if (turmasAgendadasTypeA[e].idAccount === 't_' + turmasChecked[a]) {
              // console.log('checkOverlapingDates type a turma ', turmasChecked[a] +" "+ this.checkOverlapingDates(turmasAgendadasTypeA[e]))
              if (!this.checkOverlapingDates(turmasAgendadasTypeA[e])) {
                  // console.log('date is not overlap type a')
                isValidDate = true;
                ///return isValidDate;
              } else {
                //  console.log('date is  overlap type a')
                return isValidDate;
              }
            }
          }
        }
      } else {
        isValidDate = true;
      }

      const responseTypeB = await makeRequest.get(`simulado/agendamento/turmas?idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&idEventPracticeTest=${this.state.selectedEventPracticeTest}&idPracticeTestType=${typeB}`)
        // console.log('responseTypeB',responseTypeB)

      if (responseTypeB.marcados.length > 0 && responseTypeB.marcados[0] !== null) {
        var turmasAgendadasTypeB = responseTypeB.marcados[0]

        for (var b in turmasAgendadasTypeB) {
          for (var c in turmasChecked) {
            if (turmasAgendadasTypeB[b].idAccount === 't_' + turmasChecked[c]) {
              // console.log('checkOverlapingDates type bturma ', turmasChecked[c] +" "+ this.checkOverlapingDates(turmasAgendadasTypeB[b]))
              if (!this.checkOverlapingDates(turmasAgendadasTypeB[b])) {
                //  console.log('date is not overlap type a')
                isValidDate = true;
                //return isValidDate;
              } else {
                  //  console.log('date is  overlap type b')
                return isValidDate;
              }
            }
          }
        }

      } else {
        isValidDate = true;
      }
      // console.log('datase are valid??? ', isValidDate)
      return isValidDate;
    } catch (e) {
      console.log(e);
    }

  }
  /**
   *
   *
   */
  //Used when the user is going to edit a period.
  getAlunosMarcados = async (nodeAlunos, expanded, unCheckAll = false) => {
    try {

      let alunosun = [];
      if(!unCheckAll) {
        const response = await makeRequest.get(`simulado/agendamento/marcados?event=${this.state.selectedEvent}`)
        alunosun = response.marcados;
      }
      // console.log('alunosun ',alunosun)
      // console.log('alunos marcados ', alunosun)
      // console.log('action getAlunosMarcados ', this.state.action)
      //  await this.setState({ treeViewAlunos: { ...this.state.treeViewAlunos, nodes: nodeAlunos, expanded: expanded, checked: [] } });
      await this.setState({ treeViewAlunos: { ...this.state.treeViewAlunos, nodes: nodeAlunos, expanded: expanded, checked: alunosun } });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  //ALUNOS

  /**
   * Agendamento naoRealizados=false, realizados=false
   * EDITAR, it will be available untill its period expired. When expired it will become Reagendar
   * Reagendamento naoRealizados = true; , realizados=false
   * Reagendamento, it is going to be done JUST for those students that did not make the test
   *
   * Forçar reagendamento naoRealizados=false, realizados = true;
   */
  getAgendamentoAlunos = async () => {
    // console.log('getAgendamentoAlunos ', this.state.action)
    // console.log('event ',this.state.selectedEventPracticeTest)

    // let alunos = {}
    /**
     * this.simulaodosAgendados
     * ex
     * IF idAccountType: 1 Agendamento was created for an student
     *  IF idAccountType: 1 Agendamento was created for a turma
     * { idAccountType: 1,idEvent: 333,identityclass: 38719}
     * { idAccountType: 4,idEvent: 331,identityclass: 38719}
     */

    //  console.log('agendamentooooo ',this.state.selectedSchool.idAccountSchool,this.state.selectedGrade.idGrade,this.state.selectedPracticeTestType,this.state.selectedPeriodSchoolGrade)
    // console.log('this.state.alunosChecked ',this.state.alunosChecked)

    // if(this.state.alunosChecked){ //this is only valid when editing Reagendamento
    //   alunos =  Object.keys(this.state.alunosChecked);
    //   alunos =  alunos.join();
    // }

    // console.log('alunnnn ', alunos)
    var simludados = this.simuladosAgendados
    //   console.log('current simulados ', simludados)
    //  console.log('this.state', this.state)
    var turmasDaAgenda = simludados.filter((turm) => { return turm.idEvent === this.state.idEvent })
    // console.log('turmasDaAgenda ', turmasDaAgenda)
    this.setState({ currentAgandamento: turmasDaAgenda[0] })

    turmasDaAgenda = turmasDaAgenda.map(turm => turm.identityclass)
    turmasDaAgenda = [...new Set(turmasDaAgenda)];
    var classesA = turmasDaAgenda.join()
    //    console.log('turmasDaAgendaturmasDaAgmasDaAgenda ', classesA)

    // identifica se o agendamento é para alunos ou para turma
    let agendaAlunos = false;
    if(this.state.selectedEventPracticeTest) {
      let agendamentoAtual = this.state.agendamentos.find(ag => ag.idEventPracticeTest === this.state.selectedEventPracticeTest);
      if(agendamentoAtual) {
        agendaAlunos = !agendamentoAtual.EventToClass;
      }
    }

    var naoRealizados = false;
    var realizados = false;
    var showCheckbox = false;

    // se o agendamento é para alunos exibe o check do nível de alunos
    if(agendaAlunos) {
      showCheckbox = true;
    }
    var url = `simulado/agendamento/alunos?school=${this.state.selectedSchool.idAccountSchool}&grade=${this.state.selectedGrade.idGrade}&naoRealizados=${naoRealizados}&idPracticeTestType=${this.state.selectedPracticeTestType}&idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&realizados=${realizados}`;
    // var showExpandAll =  false;
    if (this.state.action === 'reagendar') {
      /**
    * REAGENDAMENTO
    *   Reagendamento naoRealizados = true; , realizados=false
        Reagendamento, it is going to be done JUST for those students that did not make the test
    */
      naoRealizados = true;
      showCheckbox = true;
      url = `simulado/reagendamento/alunos?school=${this.state.selectedSchool.idAccountSchool}&grade=${this.state.selectedGrade.idGrade}&idPracticeTestType=${this.state.selectedPracticeTestType}&idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&class="${classesA}"`;
    }

    //   if(this.state.alunosChecked && this.state.action === 'editar'){ ///editar Reagendamento

    //     // console.log('this.state.alunosChecked s ',this.state.action)
    //    console.log('aaaluo s ',this.state.alunosChecked)
    //    naoRealizados = true;
    //    showCheckbox = true;
    //    url = `simulado/reagendamento/listaalunos?school=${this.state.selectedSchool.idAccountSchool}&grade=${this.state.selectedGrade.idGrade}&idPracticeTestType=${this.state.selectedPracticeTestType}&idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&class="${classesA}"&students="${alunos}"`;

    //  }
    if (this.state.action === 'forcarreagendar') {
      realizados = true;
      showCheckbox = true;

      url = `simulado/agendamento/alunos?school=${this.state.selectedSchool.idAccountSchool}&grade=${this.state.selectedGrade.idGrade}&naoRealizados=${naoRealizados}&idPracticeTestType=${this.state.selectedPracticeTestType}&idPeriodSchoolGrade=${this.state.selectedPeriodSchoolGrade}&realizados=${realizados}`;

    }




    try {
      // console.log('url ', url)
      // console.log('idevent ', this.idEvent)
      const response = await makeRequest.get(url)
      //  console.log('agendamento/alunos ', response)
      let nodeAlunos = [];
      let alunosApi = response;

      if (alunosApi.alunos && alunosApi.alunos.length > 0 && alunosApi.alunos !== "no modules" && alunosApi.alunos[0] !== null) {

        let alunos = alunosApi.alunos[0][0]
        let school = alunos.fSch[0]
        let expanded = [];

        var uniqueValuesSegmements = {}

        for (var yu in school.fCla) {
          uniqueValuesSegmements[school.fCla[yu].txSegment] = school.fCla[yu].txSegment
        }

        for (var we in uniqueValuesSegmements) {
          expanded.push(we)
          let nodeValue = {
            value: we, label: uniqueValuesSegmements[we], children: []
          };

          for (var a in school.fCla) {
            if (school.fCla[a].txSegment === uniqueValuesSegmements[we]) { //SERIES
              let nodeChild = {};
              nodeChild.value = "s_" + school.fCla[a].idEntityGrade;
              nodeChild.label = school.fCla[a].txGrade;
              nodeChild.children = []
              expanded.push(nodeChild.value)
              for (var i in school.fCla[a].at) { // Turmas
                let nodeChildClass = {};
                nodeChildClass.value = "t_" + school.fCla[a].at[i].idEntityClass;
                nodeChildClass.label = school.fCla[a].at[i].txClass;
                nodeChildClass.children = []
                expanded.push(nodeChildClass.value)
                for (var t in school.fCla[a].at[i].au) { //STUDENTS
                  let childrenAlunos = {};
                  childrenAlunos.value = "u_" + school.fCla[a].at[i].au[t].idStudent
                  childrenAlunos.label = school.fCla[a].at[i].au[t].txStudent
                  childrenAlunos.showCheckbox = showCheckbox;
                  nodeChildClass.children.push(childrenAlunos)
                }
                nodeChild.children.push(nodeChildClass)
              }
              nodeValue.children.push(nodeChild)
            }
          }
          nodeAlunos.push(nodeValue)
        }
        // console.log('nodeAlunos ', nodeAlunos)
        if (nodeAlunos.length > 0) {
          await this.getAlunosMarcados(nodeAlunos, expanded, this.state.action === 'forcarreagendar' || this.state.action === 'reagendar' )
        }
      }
      else {
        await this.setState({ treeViewAlunos: { ...this.state.treeViewAlunos, nodes: [], expanded: [], checked: [] } });
      }
      return;
    }
    catch (e) {
      console.log(e);
    }
  }



  getPracticeConfig = async (loadSimulado = true) => {
    // console.log('getPracticeConfig', this.state)
    try {
      if (this.state.selectedEventPracticeTest === 0) {
        await this.getAgendamentoAlunos()
      }
      else {
        const response = await makeRequest.get(`simulado/config?practiceTest=${this.state.selectedEventPracticeTest}`)
        if (response && response.length) {
          const simulado = response[0];
          if(loadSimulado) {
            await this.setState({ simulado: simulado });
          }
          //console.log('rrr ',this.state.action)
          await this.getAgendamentoAlunos()
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  //ALUNOS TURMA
  getStudentsClass = async (idevent, identityclass) => {
    try {

      /**Variable to save idevent and identityClass */
      let agendamentoTurmas = {
        // selectedEventPracticeTest:this.state.selectedEventPracticeTest,
        idEvent: idevent,
        identityclass: identityclass
      }
      const response = await makeRequest.get(`turmas/alunos?event=${idevent}&class=${identityclass}`)
      if (response && response.ret && response.ret.length) {
        let alunos = response.ret[0];
        //  console.log('evee ', response)

        let alunosevent = alunos[0].ems;

        // console.log('alunos idAccountType ', alunos[0].idAccountType )
        // console.log('alunosevent ', alunosevent)
        agendamentoTurmas.EventToClass = (alunos[0].idAccountType === 4) ? 1 : 0

        this.simuladosAgendados.push(agendamentoTurmas)

        if (alunosevent && alunosevent.length > 0) {
          return alunosevent;
        }
      }
      return "Não há alunos para essa turma";
    }
    catch (e) {
      return "Não há alunos para essa turma";
    }

  }

  showError = (error) => {
    let error_msg = error;
    if (error.startsWith("Failed to connect")) {
      error_msg = "Falha na conexão. Tente novamente... (err: 1001)";
    }
    alert(error_msg);
  }

  agendarSimulado = async () => {
    // console.log(this.state.action)
    // console.log('selectedEventPracticeTest ', this.state.selectedEventPracticeTest)
    // console.log('simulado/agendamento', this.state.simulado);
    let response = "";
    let retorno = "";
    try {
      if (this.state.selectedEventPracticeTest === 0 || this.state.action === 'reagendar') {
        // console.log('agendar ', this.state.selectedEventPracticeTest === 0 )
        // console.log('this.state.action ',this.state.action)
        // console.log('post simulado/agendamento', this.state.simulado, 'idGrade', this.state.selectedGrade.idGrade, 'idPeriodPracticeTest', this.state.selectedPeriodPracticeTest)
        // const response = ''
        const response = await makeRequest.post('simulado/agendamento', { ...this.state.simulado, idGrade: this.state.selectedGrade.idGrade, idPeriodPracticeTest: this.state.selectedPeriodPracticeTest })
        // console.log('response post ', response)
        if (!response) retorno = "Ocorreu um erro ao gravar"
        // this.showError("Ocorreu um erro gravar")
      }
      if (this.state.action === 'forcarreagendar') {
        console.log('post simulado/forcarreagendamento', this.state.simulado, 'idGrade', this.state.selectedGrade.idGrade, 'idPeriodPracticeTest', this.state.selectedPeriodPracticeTest)
        // const response = ''
        response = await makeRequest.post('simulado/forcarreagendamento', { ...this.state.simulado, idGrade: this.state.selectedGrade.idGrade, idPeriodPracticeTest: this.state.selectedPeriodPracticeTest })
        // console.log('response post ', response)
        if (!response) retorno = "Ocorreu um erro ao gravar"
        // recalcula a pontuação após a exclusão do simulado
        GamificacaoRequest.calcularPontuacaoUsuario(parseInt(this.state.simulado.arrIdAccountMembers));
        // this.showError("Ocorreu um erro gravar")
      }
      if(this.state.action === 'editar') {
        // console.log('put simulado/agendamento', this.state.simulado, 'idEvent', this.state.selectedEvent, 'idPeriodPracticeTest', this.state.selectedPeriodPracticeTest)

        const response = await makeRequest.put('simulado/agendamento', { ...this.state.simulado, idEvent: this.state.selectedEvent, idPeriodPracticeTest: this.state.selectedPeriodPracticeTest })
        // console.log(response)
        if (!response) retorno = "Ocorreu um erro ao gravar"
      }
    } catch (error) {
      console.error(error)
    }
    return retorno;
  }


  ragendarSimulado = async () => {
    // console.log(this.state.action)
    // console.log('ragendarSimulado', this.state.simulado);
    let retorno
    try {
      if (this.state.selectedEventPracticeTest === 0 || this.state.action === 'reagendar') {
        // console.log('post simulado/agendamento',this.state.simulado, 'idGrade', this.state.selectedGrade.idGrade, 'idPeriodPracticeTest',this.state.selectedPeriodPracticeTest)
        // const response = undefined
        const response = await makeRequest.post('simulado/agendamento', { ...this.state.simulado, idGrade: this.state.selectedGrade.idGrade, idPeriodPracticeTest: this.state.selectedPeriodPracticeTest })
        // console.log('response post ', response)
        if (!response) retorno = "Ocorreu um erro ao gravar"
        // this.showError("Ocorreu um erro gravar")
      }
      else {
        // console.log('put simulado/agendamento', this.state.simulado, 'idEvent',this.state.selectedEvent, 'idPeriodPracticeTest', this.state.selectedPeriodPracticeTest)
        // const response = undefined
        const response = await makeRequest.put('simulado/agendamento', { ...this.state.simulado, idEvent: this.state.selectedEvent, idPeriodPracticeTest: this.state.selectedPeriodPracticeTest })
        // console.log(response)
        if (!response) retorno = "Ocorreu um erro ao gravar"
      }
    } catch (error) {
      console.error(error)
    }
    return retorno;
  }
  excluirAgendaSimulado = async (idEventPracticeTest, idEvent) => {
    try {
      const response = await makeRequest.delete(`simulado/agendamento?simulado=${idEventPracticeTest}&evento=${idEvent}`)
      // console.log(response)
      if (response === "ok") {
        return true;
      }
      else {
        return response;
      }
    } catch (error) {
      console.error(error)
    }
  }



    /**
   * Get Students from School
   */
  getAlunosEscola = async () => {
    // console.log('idSchool ', this.state.selectedSchool)
    try {
      const response = await makeRequest.get(`escolas/alunos?school=${this.state.selectedSchool.idEntitySchool}`)
      //  console.log('ALUNOS ', response)
      let nodeAlunos = [];
      let alunosApi = response;
      let expanded = [];

      if (alunosApi && alunosApi.length > 0 && alunosApi !== "no modules" && alunosApi[0] !== null) {

        let alunos = alunosApi
        // console.log('ALUNOS ', alunos)

        let segments = {}


        for (var s in alunos) {
          let grades = []
          segments[alunos[s].txName] = alunos[s].txName;

          expanded.push(alunos[s])
          let nodeValue = {
            value: alunos[s].idSegment, label: alunos[s].txName, children: []
          };

          grades = alunos[s].grade
          // console.log(grades)
          for (var g in grades) {
            let nodeChild = {};
            nodeChild.value = "s_" + grades[g].idGrade;
            nodeChild.label = grades[g].txGrade;
            nodeChild.children = []
            expanded.push(nodeChild.value)

            let classes = grades[g].classes;
            for (var c in classes) {
              // console.log(classes[c])
              let nodeChildClass = {};
              nodeChildClass.value = "t_" + classes[c].idEntityClass;
              nodeChildClass.label = classes[c].txClass;
              nodeChildClass.children = []
              expanded.push(nodeChildClass.value)

              let students = classes[c].students;
              for (var st in students) {
                let childrenAlunos = {};
                childrenAlunos.value = "u_" + students[st].idAccount
                childrenAlunos.label = students[st].txStudentName
                childrenAlunos.showCheckbox = true;
                nodeChildClass.children.push(childrenAlunos)
              }
              nodeChild.children.push(nodeChildClass)
            }

            nodeValue.children.push(nodeChild)
          }


          nodeAlunos.push(nodeValue)
        }

      }
      await this.setState({ treeViewAlunosEstudo: { ...this.state.treeViewAlunosEstudo, nodes: nodeAlunos, expanded: expanded, checked: [] } });
      return;
    }
    catch (e) {
      console.log(e);
    }
  }


    /**
   * Get Study Details
   */
  getStudyDetails = async () => {
     //console.log('selectedStudy ', this.state.selectedStudy)
    try {
      const response = await makeRequest.get(`estudo?study=${this.state.selectedStudy}`)
      // const response = await makeRequest.get(`estudo?study=34`)
      //  console.log('response ', response)

       if (response ) {
        const study = response.etapas;
        // console.log('study ',study)
        if (study && study.length > 0) {
          return study[0];
        }
      }
      return "Não há dethales do estudo";
    }
    catch (e) {
      console.log(e);
    }
  }

  getSchoolsStudy = async () => {
    try {
      const schools = await makeRequest.get('escolas')
      //  console.log(schools)
      await this.setState({ selectedSchool: schools[0] });
    } catch (error) {
      console.error(error)
    }
  }

  saveStudy = async () => {
  //   let testSt ={
  //     "idUserMember": "u_418664,u_151088,u_404431,u_414326,u_151232,u_325616,u_151029,u_207222,u_418561,u_324699,u_151002,u_183246,u_188544,u_150963,u_151101,u_205282,u_314706,u_404005,u_151218,u_320699,u_151019,u_431417,u_182954,u_151223,u_207961,u_435477,u_430735,u_326591,u_338093,u_418691,u_150928,u_418044,u_150981,u_418571,u_151182,u_151209,u_150922,u_150984,u_151133,u_151287,u_151120,u_151113,u_151253,u_151141,u_151103,u_426421,u_151145,u_150997,u_151150,u_342120,u_207463,u_150884,u_151157,u_206145,u_326597,u_151164,u_403523,u_151271,u_151198,u_151074,u_151106,u_151166,u_427772,u_208629,u_207444,u_336691,u_151169,u_151172,u_151115,u_151110,u_371075,u_336674,u_151449,u_339007,u_199558,u_151241,u_424735,u_150911,u_151230,u_314059,u_151192,u_188568,u_151086,u_151185,u_150955,u_188585,u_151152,u_151047,u_150945,u_150926,u_151265,u_150908,u_375309,u_150942,u_151487,u_211643,u_150969,u_150999,u_151221,u_151283,u_150972,u_150887,u_150976,u_150979,u_151280,u_151077,u_333573,u_206107,u_208241,u_206169,u_314073,u_150916,u_207107,u_150918,u_151378,u_151657,u_313999,u_151473,u_151334,u_151695,u_151337,u_313451,u_434970,u_321557,u_151531,u_206190,u_151406,u_151707,u_326614,u_151381,u_207473,u_151295,u_151348,u_436270,u_151355,u_151297,u_151302,u_151306,u_151314,u_151365,u_151316,u_411193,u_339012,u_151346,u_151321,u_192937,u_151629,u_151368,u_195189,u_207490,u_151374,u_151409,u_151648,u_151508,u_151423,u_151481,u_151650,u_151389,u_151609,u_151575,u_151703,u_427944,u_406550,u_151597,u_409234,u_151631,u_151578,u_404920,u_151669,u_151641,u_151581,u_151670,u_151612,u_411448,u_151644,u_151420,u_151593,u_151653,u_151585,u_151621,u_151591,u_435317,u_185613,u_436300,u_151497,u_413919,u_416037,u_151603,u_151624,u_411748,u_151737,u_151722,u_151565,u_151467,u_326537,u_151743,u_151415,u_403879,u_151728,u_151700,u_151404,u_151476,u_151482,u_401132,u_408434,u_409849,u_429961,u_151564,u_371084,u_151463,u_151666,u_151395,u_333020,u_151545,u_151492,u_151517,u_151638,u_206217,u_151543,u_151400,u_321608,u_429245,u_151691,u_317861,u_151436,u_151439,u_151443,u_151340,u_151328,u_414035,u_200323,u_222739,u_320386,u_152058,u_208290,u_152025,u_433121,u_317998,u_152085,u_200310,u_413844,u_151969,u_435297,u_151943,u_151901,u_151902,u_151880,u_320417,u_151910,u_152066,u_152109,u_151875,u_151996,u_151839,u_198253,u_151758,u_198326,u_207569,u_152000,u_152002,u_151936,u_152035,u_151856,u_152014,u_205781,u_151975,u_151810,u_151819,u_152126,u_207522,u_324245,u_183571,u_151896,u_151921,u_205795,u_196870,u_221799,u_151770,u_151961,u_152132,u_151827,u_333013,u_152045,u_219942,u_313457,u_151929,u_207545,u_322715,u_151991,u_336706,u_151749,u_200250,u_341963,u_151752,u_326540,u_151823,u_151993,u_314721,u_152070,u_151791,u_152038,u_418693,u_152113,u_151847,u_151773,u_151893,u_152091,u_151865,u_437786,u_212113,u_221572,u_338085,u_152121,u_151798,u_206279,u_326647,u_332747,u_151807,u_191653,u_152080,u_151926,u_404001,u_151830,u_151870,u_151956,u_151955,u_207582,u_152064,u_151824,u_400478,u_208284,t_38522,t_38523,t_38524,t_38525,t_38715,t_38716,t_38717,t_38719,t_38720,t_38721",
  //     "idStudy": [63,43],
  //     "dtStartStudy": "2019-07-03 10:25:00",
  //     "dtEndStudy": "2019-07-16 12:05:00",
  //     "inHasSummary": 1
  // }


  //     console.log('create Study', this.state.study);
    let retorno
    try {
      //  const response = await makeRequest.post('estudos', testSt)
      //  console.log('save studyyyyy ',response)

      //  if (!response) retorno = "Ocorreu um erro ao gravar"

         const response = await makeRequest.post('estudos', { ...this.state.study })
        //  console.log('save studyyyyy ',response)
         if (!response) retorno = "Ocorreu um erro ao gravar"
         if (response === true) retorno = "Estudo criado com sucesso!"

    } catch (error) {
      console.error(error)
    }
    return retorno;
  }

}

export {
  PracticeTestContainer
}